import { SeuEnvironment } from '@seu-types';

export const SEU_ENVIRONMENT: SeuEnvironment = {
  production: true,
  env: 'qa',
  apiUrl: 'https://api.test.processdesigner.scheuch.com',
  msal: {
    clientId: '5eb286c0-9610-4883-81a6-685cdd52bc3d',
    authority:
      'https://login.microsoftonline.com/a2fcf037-4226-400e-8442-294f22277f3b',
    redirectUrl: {
      cdnUrl: 'https://test.processdesigner.scheuch.com/',
      azureUrl: 'https://scheuchpdteststoreweb.z6.web.core.windows.net/',
    },
  },
  isEnvSwitchAllowed: true,
  mock: false,
  sentryEnabled: true,
  isCanvasDevToolsEnabled: false,
};
